import { render, staticRenderFns } from "./EducationalService.vue?vue&type=template&id=515edfab&scoped=true"
import script from "./EducationalService.vue?vue&type=script&lang=js"
export * from "./EducationalService.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/radio-button.css?vue&type=style&index=0&id=515edfab&prod&scoped=true&lang=css&external"
import style1 from "./EducationalService.vue?vue&type=style&index=1&id=515edfab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515edfab",
  null
  
)

export default component.exports